// ScheduleSection

import Container from "../../../components/ui/Container";
import SectionHeader from "../../../components/ui/SectionHeader";
import { scheduleItems } from "../constants/scheduleData";

export default function ScheduleSection() {
  return (
    <section
      id="program"
      className="event-noise border-y border-white/10 bg-twilight-indigo-900 px-0 py-16 text-white md:py-24 lg:py-28"
    >
      <Container>
        <div className="max-w-3xl">
          <SectionHeader
            eyebrow="Event Program"
            title="Inauguration"
            accent="Ceremony"
            description="A formal sequence of ceremonial activities prepared for the installation of newly elected officials."
            align="left"
          />

          {/* <div className="mt-10 h-20 w-px bg-amber-flame-500/50 md:h-24" /> */}
        </div>

        {/* <div className="mt-12 border-t border-white/10 md:mt-16"> */}
        <div className="mt-10 border-t border-white/10 md:mt-12">
          {scheduleItems.map((item) => (
            // <div
            //   key={`${item.time}-${item.title}`}
            //   className="grid grid-cols-[88px_1fr] gap-4 border-b border-white/10 py-5 sm:grid-cols-[120px_1fr] sm:gap-6 md:grid-cols-[160px_1fr] md:gap-10 md:py-6 lg:grid-cols-[180px_1fr]"
            // >
            //   <p className="pt-1 text-[0.65rem] font-semibold uppercase tracking-[0.22em] text-amber-flame-500 sm:text-xs sm:tracking-[0.25em]">
            //     {item.time}
            //   </p>

            //   <p className="font-serif text-xl leading-snug text-white sm:text-2xl md:text-3xl">
            //     {item.title}
            //   </p>
            // </div>
            <div
              key={`${item.time}-${item.title}`}
              className="grid grid-cols-[82px_1fr] gap-4 border-b border-white/10 py-5 sm:grid-cols-[105px_1fr] sm:gap-5 md:grid-cols-[120px_1fr] md:gap-6 md:py-6 lg:grid-cols-[130px_1fr]"
            >
              <p className="pt-1 text-[0.65rem] font-semibold uppercase tracking-[0.22em] text-amber-flame-500 sm:text-xs sm:tracking-[0.25em]">
                {item.time}
              </p>

              <p className="font-serif text-xl leading-snug text-white sm:text-2xl md:text-3xl">
                {item.title}
              </p>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}